/**
 * react-html-parser の ラップ関数
 * https://github.com/remarkablemark/html-react-parser
 */
import clsx from 'clsx';
import ReactHtmlParser, { convertNodeToElement, processNodes, } from 'react-html-parser';
/**
 * Node を ReactElement に変換
 * @param node
 * @param index
 * @param transform
 */
export const convertNodeToReactElement = convertNodeToElement;
/**
 * HTML文字列を ReactElement に変換
 * @param html 変換対象のHTML文字列
 * @param options 変換時のオプション
 * @returns
 */
export const reactHtmlParser = ReactHtmlParser;
/**
 * 対象のタグに特定の className を付与
 */
export const transformHtml = (settings) => {
    const transform = (node, index) => {
        if (node.type !== 'tag') {
            return undefined;
        }
        const targetSetting = settings === null || settings === void 0 ? void 0 : settings.find((setting) => setting.tagName === node.name);
        // className の変換指定がある場合 対象の className 付与
        if (targetSetting === null || targetSetting === void 0 ? void 0 : targetSetting.className) {
            const convertedNode = node;
            convertedNode.attribs.class = clsx(convertedNode.attribs.class || '', targetSetting.className);
            return convertNodeToReactElement(convertedNode, index, transform);
        }
        // 変換対象のコンポーネントがある場合 コンポーネントを返す
        if (targetSetting === null || targetSetting === void 0 ? void 0 : targetSetting.component) {
            return targetSetting.component(index, processNodes(node.children, transform));
        }
        return undefined;
    };
    return transform;
};
